export type DraftWizardStepKind = 'project' | 'units' | 'dates' | 'services'

export interface DraftWizardStep {
    kind: DraftWizardStepKind
    /** Present for schedule steps. */
    phaseId?: number
    phaseIndex?: number
    phaseCount?: number
}

export interface TermLeaseContext {
    move_out_date: string | null
    move_in_date: string | null
    move_out_count?: number
    move_in_count?: number
    reliable?: boolean
}

export function scheduleNeedsConfirmWizard(schedule: {
    review_status?: string
    schedule_review_status?: string
}): boolean {
    return (
        schedule.review_status === 'DRAFT' ||
        schedule.schedule_review_status === 'PENDING'
    )
}
